export interface CsvRow {
  [key: string]: string | number | null | undefined;
}

const defaultFormatter = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) {
    return '';
  }
  return String(value);
};

export const buildCsvContent = (
  headers: string[],
  rows: Array<Array<string | number | null | undefined>>,
  formatter: (value: string | number | null | undefined) => string = defaultFormatter
): string => {
  const escapedHeaders = headers.map((header) => escapeCsvCell(header));
  const escapedRows = rows.map((row) =>
    row
      .map((value) => escapeCsvCell(formatter(value)))
      .join(',')
  );
  return [escapedHeaders.join(','), ...escapedRows].join('\n');
};

const UTF8_BOM = '\uFEFF'; // Excel expects UTF-8 files with a BOM to detect encoding correctly

export const downloadCsv = (content: string, filename: string) => {
  const blob = new Blob([UTF8_BOM + content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const escapeCsvCell = (value: string): string => {
  const escaped = value.replace(/"/g, '""');
  return `"${escaped}"`;
};
